export default __webpack_public_path__ + "static/media/Course-Icons10.1c7b239d.svg";